export function toggleModal(modalName) {
    let modalEl = document.querySelector(`#${modalName}`); // 모달 불러올 input
    if (!modalEl) {
        modalEl = document.querySelector(`.${modalName}`)
    }
    let modalBg = document.querySelector(".modalBackColor") // 모달 뒷배경
    let body = document.querySelector('body'); // 모달 나타났을때 뒤에 고정
    let modalNum = modalEl.getAttribute('data-modal'); // 각 모달 data set 가져오기
    let showEl = document.querySelector(`.modal_no${modalNum}`) // 해당 모달
    body.style.overflow = 'hidden';
    body.style.position = 'fixed';
    body.style.width = '100%';
    modalBg.style.display = 'block';
    showEl.style.display = 'block';
    // console.log('modalEl', modalEl, modalNum, showEl);
    let closeBtn = document.querySelector(`.modal_no${modalNum} .mdcolsebtn`);
    if (!closeBtn) {
        closeBtn = document.querySelector('.pop_close')
    }

    closeBtn.addEventListener('click', function () {
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        modalBg.style.display = 'none'
        showEl.style.display = 'none'
    })
}